export default {
    thisWeekColor: '#5cbcd9',
    todayColor: '#fbc405',
    allDayColor: '#a4d1df',
    textColor: '#2963a8',
    sideBarTimeColor: '#fbc405',
    energyBackgroundColor: '#d8dadb',
    blackColor: '#494d43'
}